var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * DefaultPluginTypes
 *
 * Enum including the defaultEvent types. (eg. defaultClick, defaultPageView, defaultImpression, ...)
 * This can be added with new events as we introduce them.
 *
 * @export
 * @enum {string}
 */
export var DefaultPluginTypes;
(function (DefaultPluginTypes) {
    DefaultPluginTypes["defaultPageView"] = "defaultPageView";
    DefaultPluginTypes["defaultClick"] = "defaultClick";
})(DefaultPluginTypes || (DefaultPluginTypes = {}));
/**
 * ControlPluginTypes
 *
 * Enum including the controlEvent types. (eg. controlClick, controlImpression, ...)
 * This can be added with new events as we introduce them.
 *
 * Control events are not enabled by default for consumers. These types of events gives more refined control
 * for consumers to handle interactions.
 *
 * More details in Readme.md
 *
 * @export
 * @enum {string}
 */
export var ControlPluginTypes;
(function (ControlPluginTypes) {
    ControlPluginTypes["controlClick"] = "controlClick";
})(ControlPluginTypes || (ControlPluginTypes = {}));
/**
 * @export
 * @constant
 */
export var PluginTypes = __assign(__assign({}, DefaultPluginTypes), ControlPluginTypes);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvcGx1Z2lucy9lbnVtcy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztBQUFBOzs7Ozs7OztHQVFHO0FBQ0gsTUFBTSxDQUFOLElBQVksa0JBR1g7QUFIRCxXQUFZLGtCQUFrQjtJQUM1Qix5REFBbUMsQ0FBQTtJQUNuQyxtREFBNkIsQ0FBQTtBQUMvQixDQUFDLEVBSFcsa0JBQWtCLEtBQWxCLGtCQUFrQixRQUc3QjtBQUVEOzs7Ozs7Ozs7Ozs7O0dBYUc7QUFDSCxNQUFNLENBQU4sSUFBWSxrQkFFWDtBQUZELFdBQVksa0JBQWtCO0lBQzVCLG1EQUE2QixDQUFBO0FBQy9CLENBQUMsRUFGVyxrQkFBa0IsS0FBbEIsa0JBQWtCLFFBRTdCO0FBRUQ7OztHQUdHO0FBQ0gsTUFBTSxDQUFDLElBQU0sV0FBVyx5QkFBUSxrQkFBa0IsR0FBSyxrQkFBa0IsQ0FBRSxDQUFDIn0=